import { render } from "./CompanyCard.vue?vue&type=template&id=5da1b963&scoped=true&ts=true"
import script from "./CompanyCard.vue?vue&type=script&lang=ts"
export * from "./CompanyCard.vue?vue&type=script&lang=ts"

import "./CompanyCard.vue?vue&type=style&index=0&id=5da1b963&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da1b963"]])

export default __exports__